export default __webpack_public_path__ + "static/color-tokens-in-screen-light-c0903fea11305c4e8462d03d0752a5a7289a3cd6ecf4616b9b3f92e00e5ffc40.png";